export default __webpack_public_path__ + "static/media/home_ems_device_icon.0463827d.svg";